import { useSubscriptionState } from "@/zustand/SubscriptionState";
import { PLAN_LIMITS } from "@/config/subscriptionPlans";

/**
 * Returns the feature limits that apply to the current user's subscription plan.
 * All values are derived from PLAN_LIMITS in subscriptionPlans.ts — edit limits there.
 */
export function usePlanLimits() {
  const plan = useSubscriptionState((s) => s.subscription.plan);

  return {
    /** Maximum voice note duration in milliseconds */
    voiceNoteDuration: PLAN_LIMITS.voiceNoteDuration[plan],
  };
}
